import { PropsWithChildren } from 'react';

import { typographyStyle, Colors, Flex } from '@revenuemarket/cds';
import { Typography } from 'antd';

interface Props extends PropsWithChildren {
  title: string;
  style?: React.CSSProperties;
  className?: string;
}

const NavGroup: React.FC<Props> = ({ title, children, style, className }) => {
  return (
    <Flex
      direction="column"
      style={{
        ...style,
      }}
      className={className}
    >
      <Typography.Text
        style={{
          ...typographyStyle['13_600'],
          marginBottom: 8,
          color: Colors.gray400,
          padding: '0px 8px',
        }}
      >
        {title}
      </Typography.Text>
      {children}
    </Flex>
  );
};

export default NavGroup;
